'use client';

import { ShopContext } from '@/stores/shop/context';
import { ShopProps, ShopStore, createShopStore } from '@/stores/shop/store';
import React, { useRef } from 'react';

type ShopProviderProps = React.PropsWithChildren<Partial<ShopProps>>;

export default function ShopProvider({
  children,
  ...props
}: ShopProviderProps) {
  const storeRef = useRef<ShopStore>(undefined);
  if (!storeRef.current) {
    storeRef.current = createShopStore(props);
  }

  return (
    <ShopContext.Provider value={storeRef.current}>
      {children}
    </ShopContext.Provider>
  );
}
